import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UiService } from 'src/app/admin/service/ui.service';
import { FiltroUbicacionComponent } from '../filtro-ubicacion/filtro-ubicacion.component';
@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.scss'],
})
export class BuscadorComponent implements OnInit{
  equalityIcon = '/assets/img/icons/ico-equalization-gray.svg';
  lupaIcon = '/assets/img/icons/ico-lupa-white.svg';
  searchTerm: string;
  search: string;

  country: string;
  city: string;
  sector: string;

  constructor(
    private navCtrl: Router,
    private uiSv: UiService
  ) {}

  ngOnInit(): void {
    this.country = localStorage.getItem('country') || 'Venezuela';
    this.city = localStorage.getItem('city') || 'Todos';
    this.sector = localStorage.getItem('sector');
  }

  buscar(event: any, d?) {
    const code = event.keyCode || event.which;
    if (code === 13 || d) {
      console.log('Entre', code);
      const temp: string = this.search || '';
      this.navCtrl.navigate([
        `/directorios/buscador-negocio/${temp}/1`
      ]);
    }
  }

  async setLocation(event){
    const { data, role } = await this.uiSv.createPop(FiltroUbicacionComponent, undefined, undefined, event, true);
    if(data){
      for(const key of Object.keys(data)){
        if(data[key]?.name){
          this[key] = data[key]?.name;
          console.log(key);
          localStorage.setItem(key, data[key]?.name);
        }else{
          this.city = data.city?.name ? data.city?.name : 'Todos';
        }
      }
    }
  }
}
